document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('nav-toggle');
  var nav = document.getElementById('site-nav');
  if (!toggle || !nav) return;

  function closeNav() {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  document.addEventListener('click', function (event) {
    if (window.innerWidth >= 860) return;
    if (!nav.classList.contains('is-open')) return;
    if (nav.contains(event.target) || toggle.contains(event.target)) return;
    closeNav();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeNav();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 860) closeNav();
  });

  /* Menu déroulant "Nos collections" */
  var dropdown = document.getElementById('nav-collections-dropdown');
  var dropdownToggle = document.getElementById('nav-collections-toggle');
  var dropdownMenu = document.getElementById('nav-collections-menu');

  if (dropdown && dropdownToggle && dropdownMenu) {
    function closeDropdown() {
      dropdown.classList.remove('is-open');
      dropdownMenu.classList.remove('is-open');
      dropdownToggle.setAttribute('aria-expanded', 'false');
    }

    dropdownToggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var isOpen = dropdown.classList.toggle('is-open');
      dropdownMenu.classList.toggle('is-open', isOpen);
      dropdownToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function (event) {
      if (!dropdown.classList.contains('is-open')) return;
      if (dropdown.contains(event.target)) return;
      closeDropdown();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDropdown();
    });

    window.addEventListener('resize', closeDropdown);
  }
});
